import { useMemo } from "react";
import VideoJS from "src/components/compounds/VideoJS/VideoJS";

// Click-to-play HLS player for a team's live game stream. Memoized so status polling on the
// parent never re-creates the Video.js options object and reloads the stream mid-playback.
// Shared by the team home page's Live section and the global Live page.
const LivePlayer = ({ teamId, eventId, poster }: { teamId: string; eventId: string; poster: string }) => {
  const options = useMemo(
    () => ({
      controls: true,
      autoplay: false, // click-to-play
      liveui: true,
      fill: true,
      poster,
      sources: [
        {
          src: `${process.env.REACT_APP_API_SERVER_URL}/teams/${teamId}/schedule/${eventId}/video-stream/playlist.m3u8`,
          type: "application/x-mpegURL",
        },
      ],
    }),
    [teamId, eventId, poster]
  );

  return <VideoJS options={options} onReady={() => {}} />;
};

export default LivePlayer;
